import { ArrowRight } from "lucide-react";
import { useLang, scrollToId } from "../App";
import Reveal from "./Reveal";

export default function CtaSection() {
  const { t } = useLang();
  return (
    <section data-testid="cta-section" className="bg-ink px-6 py-32 text-ivory md:px-12 md:py-44 lg:px-20">
      <div className="max-w-5xl">
        <Reveal>
          <h2 className="font-serif text-4xl font-medium leading-[1.15] sm:text-5xl lg:text-7xl">
            {t.cta.headline}
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 font-serif text-3xl italic text-champagne sm:text-4xl lg:text-5xl">{t.cta.sub}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <button
            data-testid="cta-section-button"
            onClick={() => scrollToId("contact")}
            className="group mt-14 flex items-center gap-4 bg-bronze px-10 py-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-ivory transition-colors duration-500 hover:bg-champagne hover:text-ink md:text-xs"
          >
            {t.cta.button}
            <ArrowRight size={15} className="transition-transform duration-500 group-hover:translate-x-1.5" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
